import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { getProxyAccessList, ProxyAccessListResponse } from 'services';

export type ProxyAccessListState = ApiState<ProxyAccessListResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchProxyAccessList = createAsyncThunk('get/proxyAccessList', async () => await getProxyAccessList());

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: {},
  error: null,
} as ProxyAccessListState;

//https://redux-toolkit.js.org/api/createSlice
const proxyAccessListSlice = createSlice({
  name: 'proxyAccessList',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProxyAccessList.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchProxyAccessList.fulfilled, (state, action: PayloadAction<ProxyAccessListResponse>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchProxyAccessList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { proxyAccessList: ProxyAccessListState }): ProxyAccessListState =>
  state.proxyAccessList;

export const proxyAccessList_ = createSelector(stateSelector_, (state) => state.data);

export const proxyAccessListIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const proxyAccessListHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export default proxyAccessListSlice.reducer;
